export const LOGINUSER = "LOGINUSER";
export const LOGOUTUSER = "LOGOUTUSER";
export const REGISTERUSER = "REGISTERUSER";
export const REGISTERERRORS = "REGISTERERRORS";
export const VALIDATECODE = "VALIDATECODE";
export const ERRORCODE = "ERRORCODE"
